let defaultState = {
    errorHappened: false,
    error: null
};

const eid = (state = defaultState, action) => {
    switch (action.type) {
        case 'AUTH_SIGN_ERROR':
            return {
                ...state,
                errorHappened: true,
                error: action.error
            };
        case 'PERFORM_LOGIN':
        case 'EID_CORRECT_CARD_REMOVED':
            return {
                ...state,
                errorHappened: false,
                error: null
            };
        default:
            return state
    }
}

export default eid


// WEBPACK FOOTER //
// ./src/reducers/authentication.js